import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLIC_KEY } from "./constants";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
export const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
